import { useEffect, useState } from 'react'
import { AxiosResponse } from 'axios'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import { errorMapper } from '@utils/errorMapper'
import { ErrorMessages } from '@constants/errors'
import { useMessage } from '@hooks/useMessage'
import moment from 'moment'
import { ICrmInfoDto } from '@dto/crm/crmInfo.dto'

interface Props {
  crmId?: string
  dates: [moment.Moment, moment.Moment]
}

const useCrmInfoApi = ({ crmId, dates }: Props) => {
  const { error } = useMessage()
  const [isLoading] = useState(false)
  const [result, setResult] = useState<ICrmInfoDto>()
  const getData = async () => {
    if (crmId) {
      try {
        const { data }: AxiosResponse<ICrmInfoDto> = await axiosInstance.get(
          serverPath.CRM_INFO + crmId,
          {
            params: { dates: [dates[0].format(), dates[1].format()] },
          },
        )
        setResult(data)
      } catch (e) {
        error(errorMapper(ErrorMessages.GET_DATA, e), ErrorMessages.SERVER_ERROR)
      }
    }
  }

  useEffect(() => {
    getData().then()
  }, [crmId, dates])

  return { result: result, isLoading: isLoading ?? false }
}

export default useCrmInfoApi
